// extracted by mini-css-extract-plugin
export default {"ns_label_title":"NSLabel_ns_label_title__ON7tx","ns_label_desciption":"NSLabel_ns_label_desciption__gWJ6b","ns_label_item":"NSLabel_ns_label_item__36kKc"};